/**
 * 노후화 분석 질의 — 두 원천을 위젯 여러 개가 함께 쓴다 (같은 키라 한 번만 받는다).
 * 필터를 타지 않으므로 키에 필터가 없다 (§8.11.4 필터).
 */

import { useQuery } from '@tanstack/react-query'

import { fetchEnvelope } from '@/lib/api'
import type { AgingKecoData, AgingPublicData } from '@/lib/types'

export function useAgingPublic() {
  return useQuery({
    queryKey: ['aging/public'],
    queryFn: ({ signal }) =>
      fetchEnvelope<AgingPublicData>('/aging/public', { mode: 'standard' }, {}, signal),
    staleTime: 10 * 60 * 1000,
  })
}

export function useAgingKeco() {
  return useQuery({
    queryKey: ['aging/keco'],
    queryFn: ({ signal }) =>
      fetchEnvelope<AgingKecoData>('/aging/keco', { mode: 'standard' }, {}, signal),
    staleTime: 10 * 60 * 1000,
  })
}
